import { Link } from 'react-router'
import { RiArrowRightLine } from 'react-icons/ri'
import { ROUTES } from '@/constants/routes'
import aboutHeroImage from '@/assets/images/About Me Page.png'

export const AboutHeroSection = () => (
  <section className="relative bg-white overflow-hidden">
    {/* Crimson bleed behind the portrait side */}
    <div
      aria-hidden="true"
      className="absolute top-0 left-0 bottom-0 w-[44%] bg-crimson-50 hidden lg:block"
    />

    {/* Gold decorative top border */}
    <div className="absolute top-0 inset-x-0 h-[3px] bg-gradient-to-r from-gold-500 via-crimson-600 to-transparent" />

    <div className="relative z-10 max-w-[1200px] mx-auto px-6 lg:px-12">
      <div className="flex flex-col lg:flex-row items-stretch min-h-[88vh]">
        {/* ── Left: Portrait ── */}
        <div className="w-full lg:w-[44%] shrink-0 flex items-end justify-center lg:justify-start pb-0 lg:pb-16 pt-16 lg:pt-24">
          <div
            className="relative w-full max-w-[340px] lg:max-w-none animate-fade-in-up"
            style={{ animationDelay: '0.15s' }}
          >
            {/* Portrait frame */}
            <div className="aspect-[3/4] rounded-2xl lg:rounded-r-none lg:rounded-l-2xl overflow-hidden shadow-[0_32px_64px_rgba(155,28,28,0.18)]">
              <img
                src={aboutHeroImage}
                alt="Simone — founder of H.E.R Birth Keeper"
                className="w-full h-full object-cover object-top"
              />
            </div>

            {/* Floating 15+ badge */}
            <div
              className="absolute -bottom-5 -right-5 lg:-right-8 bg-white rounded-2xl px-5 py-4 shadow-[0_12px_32px_rgba(155,28,28,0.15)] animate-fade-in-up border border-base-100"
              style={{ animationDelay: '0.5s' }}
            >
              <p className="font-display text-4xl font-bold text-gold-500 leading-none">15+</p>
              <p className="text-xs text-base-500 font-medium mt-1 whitespace-nowrap">
                Years Advocacy Experience
              </p>
            </div>

            {/* Gold decorative rings */}
            <div
              aria-hidden="true"
              className="absolute -top-6 -left-6 w-32 h-32 rounded-full border-2 border-gold-300 opacity-50"
            />
            <div
              aria-hidden="true"
              className="absolute -top-3 -left-3 w-20 h-20 rounded-full border border-gold-200 opacity-40"
            />

            {/* Name plate */}
            <div className="mt-8 lg:mt-6 text-center lg:text-left">
              <p className="font-display font-bold text-base-900 text-lg">Simone</p>
              <p className="text-[11.5px] text-crimson-600 font-semibold uppercase tracking-[0.2em] mt-0.5">
                Founder, H.E.R Birth Keeper
              </p>
            </div>
          </div>
        </div>

        {/* ── Right: Content ── */}
        <div className="flex-1 flex items-center py-16 lg:py-24 lg:pl-16 xl:pl-24">
          <div className="space-y-7 max-w-lg">
            {/* Heading */}
            <h1
              className="font-display font-bold text-base-900 leading-[1.03] animate-fade-in-up"
              style={{ fontSize: 'clamp(2.25rem, 5.5vw, 4.25rem)', animationDelay: '0.2s' }}
            >
              Your Antenatal and
              <br />
              <em className="text-crimson-600 not-italic italic">Postpartum Birthkeeper</em>
              <br />
              By Your Side
            </h1>

            {/* Divider */}
            <div
              className="w-14 h-[3px] rounded-full bg-gradient-to-r from-crimson-600 to-gold-500 animate-fade-in"
              style={{ animationDelay: '0.35s' }}
            />

            {/* Subheading */}
            <p
              className="font-display italic text-base-600 text-xl lg:text-2xl leading-relaxed animate-fade-in-up"
              style={{ animationDelay: '0.4s' }}
            >
              Bringing a calm, patient, and compassionate presence on your journey
            </p>

            {/* Credential line */}
            <p
              className="text-[13px] text-base-500 uppercase tracking-[0.18em] font-medium animate-fade-in"
              style={{ animationDelay: '0.48s' }}
            >
              Over 15+ years experience specialising in advocacy support
            </p>

            {/* CTA */}
            <div
              className="flex flex-wrap gap-3 pt-2 animate-fade-in-up"
              style={{ animationDelay: '0.55s' }}
            >
              <Link to={ROUTES.ENQUIRY} className="btn-primary">
                Book a Free Support Call
                <RiArrowRightLine size={17} />
              </Link>
              <Link to={ROUTES.SERVICES} className="btn-outline">
                View Services
                <RiArrowRightLine size={17} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
)
